<div [formGroup]="parentForm" id="extra-prompts-container">
  <mm-radio-control *ngIf="!showBundledPrompts" [parentForm]="extraPromptsGroup" [radioModel]="useStandingAuthModel"
    class="big-bottom-spacer" data-testid="useStandingAuthControl">
  </mm-radio-control>
  <mm-radio-control *ngIf="showBundledPrompts" [parentForm]="extraPromptsGroup" [radioModel]="bsloaModel" class="big-bottom-spacer" data-testid="bsloaPrompts">
  </mm-radio-control>
  <mm-radio-control *ngIf="useBundledPromptsSelected" [parentForm]="extraPromptsGroup" [radioModel]="useBundledModel"
      class="big-bottom-spacer" data-testid="itBundledStandingAuthPrompts">
  </mm-radio-control>
  <ng-container *ngIf="showStandingAuthControl">
    <mm-standing-authorization-card-container
      *ngIf="enableUseSloaContainer; else legacyStandingAuthControl"
      [label]="'Select standing authorization'"
      [authorizationCount]="standingAuthCards.length"
      [cards]="standingAuthCards"
      (cardSelected)="onStandingAuthCardSelected($event)">
    </mm-standing-authorization-card-container>
    <ng-template #legacyStandingAuthControl>
      <mm-card-component [parentForm]="extraPromptsGroup"
        [cardModel]="standingAuthDetailsModel" class="big-bottom-spacer" id="showStandingAuthCardControl">
      </mm-card-component>
    </ng-template>
  </ng-container>
  <ng-container *ngIf="showBundledStandingAuthSelection">
    <mm-standing-authorization-card-container
      *ngIf="enableUseSloaContainer; else legacyBundledStandingAuthControl"
      [label]="'Select standing authorization'"
      [authorizationCount]="bundledStandingAuthCards.length"
      [cards]="bundledStandingAuthCards"
      (cardSelected)="onStandingAuthCardSelected($event)">
    </mm-standing-authorization-card-container>
    <ng-template #legacyBundledStandingAuthControl>
      <mm-card-component [parentForm]="extraPromptsGroup" [cardModel]="cardModel"
        data-testid="itBundledStandingAuthSelectionControl">
      </mm-card-component>
    </ng-template>
  </ng-container>
  <mm-banners *ngIf="(showStandingAuthControl || showBundledStandingAuthSelection) && standingInstructions?.length === 0"
    [bannerText]="['There are no standing authorizations on this account.']" [type]="'error'" class="big-bottom-spacer">
  </mm-banners>
  <div *ngIf="showFrequencyControl" id="tooltip-radio-container" data-testid="tooltip-radio-container">
    <mm-radio-control  [parentForm]="extraPromptsGroup" [radioModel]="frequencySelectorModel" [ngClass]="isOneTimeTotalDist ? '' : 'big-bottom-spacer'" data-testid="itFrequencySelectorModel">
    </mm-radio-control>
    <mm-tooltip *ngIf="isPositionLotsPhase2 && (isEnableTotalDistSloaBsloaIt || (!isEnableTotalDistSloaBsloaIt && !standingAuth))" [position]="'right'" [containsLink]="false" id="total-dist-radio-tooltip" data-testid="total-dist-radio-tooltip">
      <tooltip-content>
        <div>{{totalDistributionTooltip}}</div>
      </tooltip-content>
      <tooltip-trigger-element>
        <sdps-icon color="active" type="functional" name="info" size="small"></sdps-icon>
      </tooltip-trigger-element>
    </mm-tooltip>
  </div>
  <mm-banners *ngIf="isOneTimeTotalDist"
    [bannerText]=[totalDistributionConstants.totalDistributionWarningText] [type]="'warning'" class="big-bottom-spacer">
  </mm-banners>
  <mm-radio-control *ngIf="showTransferType" [parentForm]="extraPromptsGroup" [radioModel]="transferTypeModel"
    class="big-bottom-spacer"></mm-radio-control>
  <mm-radio-control *ngIf="isOneTimeTotalDist" [parentForm]="extraPromptsGroup" [radioModel]="closeAccountModel"
    class="big-bottom-spacer">
  </mm-radio-control>
  <mm-reports-statements-section *ngIf="isOneTimeTotalDist" class="big-bottom-spacer"
    [parentForm]="extraPromptsGroup" [editFormDetails]="editFormDetails"></mm-reports-statements-section>
</div>
